import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";

const Integration = () => {
    const { integration_name, company_uuid } = useParams<{ integration_name: string; company_uuid: string }>();

    useEffect(() => {
        const ssoCode = "apexaiq_sso";
        const url = `${import.meta.env.VITE_APP_API_URL}authentication/sso?sso_code=${ssoCode}&company_uuid=${company_uuid}`;
        console.log("Opening URL:", url);

        // Redirect to the SSO URL
        window.location.replace(url);
    }, []);

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100vh"
            flexDirection="column"
            gap={2}
        >
            <CircularProgress size={40} />
            <Typography variant="body1">Redirecting to SSO...</Typography>
        </Box>
    );
};

export default Integration;
